module.exports = __webpack_public_path__ + "img/tsa.b3e6bf23.webp";